export default {
  namespaced: true,
  state: () => ({
    authenticated: false,
    token: null
  }),
  getters: {
    isAuthenticated: s => s.authenticated
  },
  mutations: {
    setAuth (state, { token }) {
      state.token = token
      state.authenticated = true
    },
    logout (state) {
      state.token = null
      state.authenticated = false
    }
  },
  actions: {
    async login ({ commit }, credentials) {
      // const token = await api.login(credentials)
      // commit('SET_AUTH', { token })
    }
  }
}
